import * as React from 'react';
import { FileGetDto } from 'models/ApiModels';
import LightboxReact from 'components/LightBox/react-lightbox';

interface IState {
    index: number;
}

interface IProps {
    index?: number;
    isOpen: boolean;
    images: (FileGetDto | string)[];
    thumbnails: (FileGetDto | string)[];
    titles?: string[];
    captions?: string[];
    onClose: () => void;
}

export class ReactLightBoxGallery extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = { index: props.index || 0 };
    }

    private moveNext() {
        this.setState({ index: (this.state.index + 1) % this.props.images.length });
    }

    private movePrev() {
        this.setState({ index: (this.state.index + this.props.images.length - 1) % this.props.images.length });
    }

    private onImageLoadError(imageSrc: string, _srcType: any, errorEvent: any) {
        console.error(`Could not load image at ${imageSrc}`, errorEvent); // eslint-disable-line no-console
    }

    private checkForUpdateState(prevProps: IProps) {
        if (this.props.index != prevProps.index) {
            this.setState({ index: this.props.index });
        }
    }

    componentDidUpdate(prevProps: IProps) {
        this.checkForUpdateState(prevProps);
    }

    render() {
        const { images, thumbnails, titles, captions } = this.props;

        if (images.length == 0 || thumbnails.length == 0 || images.length != thumbnails.length) {
            return null;
        }

        const imgs = images.map((v) => typeof v["url"] == "undefined" ? v : v["url"]);
        const thumbs = thumbnails.map((v) => typeof v["url"] == "undefined" ? v : v["url"]);

        if (this.props.isOpen) {
            return (
                <LightboxReact
                    mainSrc={imgs[this.state.index]}
                    nextSrc={imgs.length == 1 ? null : imgs[(this.state.index + 1) % imgs.length]}
                    prevSrc={imgs.length == 1 ? null : imgs[(this.state.index + imgs.length - 1) % imgs.length]}

                    mainSrcThumbnail={thumbs[this.state.index]}
                    nextSrcThumbnail={imgs.length == 1 ? null : thumbs[(this.state.index + 1) % imgs.length]}
                    prevSrcThumbnail={imgs.length == 1 ? null : thumbs[(this.state.index + imgs.length - 1) % imgs.length]}

                    onCloseRequest={() => this.props.onClose()}
                    onMovePrevRequest={() => this.movePrev()}
                    onMoveNextRequest={() => this.moveNext()}
                    onImageLoadError={(src, type, event) => this.onImageLoadError(src, type, event)}

                    imageTitle={titles ? titles[this.state.index] : null}
                    imageCaption={captions ? captions[this.state.index] : null}
                />
            );
        }

        return null;
    }
}
